import React, { useContext, useEffect, useRef, useState } from 'react';
import { PrintOutlined } from '@mui/icons-material';
import { Box, Button, Container, Typography, TextField, Card } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import GradientLoader from '../../components/CommanComponents/GradientLoader';
import { DataContext } from '../../context/DataContext';
import { callPostApi } from '../../function/ApiCallFunction';

import luckydrawback from '../../assets/luckydrawback.jpg';

const LuckyDrawCouponBack = () => {

    const qrRef    = useRef();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { loginData } = useContext(DataContext);
    const store_id = loginData?.store_info?.store_id || "";
    const drawId = searchParams.get("draw_id") || "";

    const [loading,   setLoading]   = useState(false);
    const [datar,     setDatar]     = useState([]);
    const [cardCount, setCardCount] = useState(1);
    const [backImage, setBackImage] = useState("");
    const [title, setTitle] = useState("");   

    //PRINT CONFIG
    const handlePrint = useReactToPrint({
        contentRef: qrRef,
        documentTitle: "QR Cards A3",
        pageStyle: `
          @page { size: A3 landscape; margin: 10mm; }
          body {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            background: white !important;
          }
          .ld-sheet { display: flex !important; flex-wrap: wrap !important; gap: 8mm !important; width: 344mm !important; }
          .ld-card { break-inside: avoid; page-break-inside: avoid; }
        `,
      });

    /* ================= GENERATE CARDS ================= */
    useEffect(() => 
    {
      let isMounted = true;
      setLoading(true);

      if (cardCount <= 0) 
      {
          if (isMounted) setDatar([]);
          setLoading(false);
          return;
      }

      // create empty cards only
      const list = Array.from({ length: cardCount });

      if (isMounted) setDatar(list);
      setLoading(false);
      return () => { isMounted = false; };

    }, [cardCount]);

    useEffect(() => {
        if (!store_id || !drawId) return;
        let mounted = true;
        callPostApi("store-draw", { mod: "DRAW_DETAIL", data_arr: { store_id, draw_id: drawId } }).then((result) => {
            if (!mounted || result.status !== "200") return;
            setBackImage(result.data?.draw?.back_image || "");
            setTitle(result.data?.draw?.title || "");
        });
        return () => { mounted = false; };
    }, [store_id, drawId]);

    //CLEAR FILTER
    const clearFun = () => { setCardCount(1); };

  return (
    <Box>
      <Container>

          {/* BACK BUTTON */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
            <Button variant="contained" sx={{ backgroundColor: '#000000', color: '#ffffff' }} onClick={() => navigate(-1)}> Back </Button>

            

          </Box>

          {/* TITLE */}
          <Typography variant="h6"  gutterBottom sx={{ background: 'linear-gradient(195deg, #49a3f1, #1A73E8)', p: 1, color: '#ffffff',
              borderRadius: '4px', mb: 3, display: 'flex', alignItems: 'center',}}> <PrintOutlined sx={{ mx: 1 }} /> Print Lucky Draw Coupons
          </Typography>
          
          {/* PRINT BUTTON */}
          <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
            <Button variant="contained" sx={{ background: 'linear-gradient(195deg, #42424a, #191919)', color: '#ffffff', ml:1}}
              onClick={handlePrint} > <PrintOutlined sx={{ mx: 1 }} /> Print </Button >           
          </Box>
       
          {/* FILTER */}
          <Box sx={{ display: 'flex',flexWrap:'wrap', gap: 2, mb: 2 }}>        
            <TextField  label="Card Count" value={cardCount} onChange={(e) => setCardCount(Number(e.target.value) || 0)} sx={{ minWidth: 160 }}
              helperText={title ? `${title}${backImage ? "" : " · default back image"}` : "Select a draw from Print to use its back image"} /> 
            
            <Button variant="outlined" color="error" sx={{ height: 56 }} onClick={() => {clearFun()}}> Clear Filter </Button>
          
          </Box>
      
          <Box ref={qrRef} className="ld-sheet" sx={{ display: "flex", flexWrap: "wrap", gap: "8mm", width: "344mm", boxSizing: "border-box" }}>
              {datar.length > 0 ? (
                datar.map((item, idx) => (
                  <Card key={idx} className="ld-card" sx={{ width: "168mm", height: "84mm", borderRadius: 0, position: "relative", overflow: "hidden", backgroundImage: `url(${backImage || luckydrawback})`,
                        backgroundSize: "100% 100%", backgroundRepeat: "no-repeat", backgroundPosition: "center", boxShadow: "none",
                        border: "1px dashed #9aa3b2", pageBreakInside: "avoid", breakInside: "avoid" }} />
                ))
              ) : ( <Typography sx={{ p: 3, color: "#888" }}> No QR data available. </Typography> )}
          </Box>

    
      </Container>

       {loading && <GradientLoader text="Loading" />}        {/* // loader */}
    </Box>
  );

}

export default LuckyDrawCouponBack;